<template>
  <div class="h-full">
    <div>
      <div class="text-2xl text-[#09518C] mt-2 lg:mt-0">Ticket</div>
      <div class="text-sm text-gray-500">
        Create your Complaints, feedbacks and inquiries here.
      </div>
    </div>
    <div class="mt-4">
      <div class="md:px-8 md:py-4" v-if="mainPage">
        <div class="md:flex justify-between items-center">
          <div class="pl-3 flex items-center shadow bg-gray-100 border">
            <font-awesome-icon
              icon="fa-solid fa-magnifying-glass text-gray-800"
            />
            <input
              class="appearance-none bg-gray-100 rounded py-2.5 px-2 leading-tight md:py-1.5 focus:outline-none focus:shadow-outline"
              type="text"
              placeholder="Search..."
              v-model="filter"
            />
          </div>
          <div class="mt-2">
            <button
              class="bg-[#8DC63F] rounded-lg text-white uppercase font-bold px-4 py-1.5 w-full md:w-auto hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300"
              @click="togglePage"
            >
              Create New Ticket
            </button>
          </div>
        </div>
        <div>
          <div class="mb-4 mt-2">
            <div
              class="text-center text-[#8DC63F] my-3"
              v-if="
                $store.state.getTickesLoading == false && tickets.length === 0
              "
            >
              No Transaction Available for the specified period
            </div>
            <LoadingSpinner
              v-if="$store.state.getTickesLoading && !displayedTickets"
            />
            <div
              class="py-4 grid gap-4 md:grid-cols-3 lg:grid-cols-2 grid-cols-3-custom"
            >
              <div
                class="p-3 cursor-pointer border-2 border-[#8DC63F] rounded shadow-sm text-[#09518C]"
                v-for="item in displayedTickets"
                :key="item.id"
                @click.prevent="openTIcketModal(item)"
              >
                <div class="flex justify-between">
                  <!-- <span class="text-sm text-gray-400 block w-8/12"
                    >{{ item?.interactionSubCategory }}
                  </span> -->
                  <span class="text-sm text-gray-400">Last Modified</span>
                  <span class="text-xs text-end">{{
                    item?.CreatedDate?.split(" ")[0]
                  }}</span>
                </div>
                <div class="flex text-sm justify-between">
                  <span class="text-gray-400 text-sm">Case Number</span>
                  <span class="text-xs text-end">{{ item?.CaseNumber }}</span>
                </div>
                <div class="flex text-sm justify-between">
                  <span class="text-gray-400 text-sm">Case Status</span>
                  <span class="text-xs text-end">{{ item?.CaseStatus }}</span>
                </div>
              </div>
            </div>
          </div>
          <pagination
            v-model="page"
            :records="tickets.length"
            :per-page="perPage"
          />
        </div>

        <div id="viewTicketModal">
          <transition name="fade">
            <div class="fixed inset-0 z-40" v-if="viewTicketModal">
              <div
                class="absolute inset-0 bg-black bg-opacity-75"
                @click="closeTicketModal"
              ></div>
              <div
                class="flex flex-col items-center justify-center w-screen h-screen"
              >
                <div class="relative animodal-inner">
                  <div
                    class="rounded-lg bg-white border w-[100%] p-6 border-stone-500 overflow-hidden lg:w-[400px]"
                  >
                    <div class="flex justify-between items-center mb-3">
                      <div class="font-bold text-sm">View Ticket</div>
                      <font-awesome-icon
                        @click="closeTicketModal"
                        class="mt-1 cursor-pointer bg-gray-300 text-gray-700 py-1 px-2 rounded-full hover:bg-gray-800 hover:text-white"
                        prefix="far"
                        icon="fa-times"
                      />
                    </div>
                    <hr />
                    <div class="flex justify-between py-2">
                      <span class="text-sm text-gray-400"
                        >{{ getCurrentData?.InteractionSubCategory }}
                      </span>
                      <span class="">{{
                        getCurrentData?.CreatedDate?.substring(0, 10)
                      }}</span>
                    </div>
                    <hr />

                    <div class="flex justify-between py-2">
                      <span class="text-sm text-gray-400">Case Number: </span>
                      <span>{{ getCurrentData?.CaseNumber }}</span>
                    </div>
                    <hr />

                    <div class="flex justify-between py-2">
                      <span class="text-sm text-gray-400">Case Status: </span>
                      <span>{{ getCurrentData?.CaseStatus }}</span>
                    </div>
                    <hr />

                    <div class="py-2 flex justify-between">
                      <span class="text-sm text-gray-400">Case Category: </span>
                      <span>{{ getCurrentData?.InteractionCategory }}</span>
                    </div>
                    <hr />

                    <div class="py-2 flex justify-between">
                      <span class="text-sm text-gray-400">Case Status: </span>
                      <span>{{ getCurrentData?.InteractionType }}</span>
                    </div>
                    <hr />

                    <div class="py-2 justify-between">
                      <span class="text-sm text-gray-400"
                        >Case Description:</span
                      >
                      <span class="block">
                        {{ getCurrentData?.CaseDescription }}
                      </span>
                    </div>
                    <hr />
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <form
        ref="ticketPageSubmit"
        class="px-8 py-2 mx-auto my-5 border bg-white shadow-lg rounded lg:w-1/2"
        v-if="mainPage === false"
        @submit.prevent="submitTicket"
        :class="{ valid: !v$.$error && v$.$dirty, error: v$.$error }"
      >
        <div class="pt-4">
          <p class="block text-gray-700 text-sm font-bold mb-2">
            <span class="text-red-500">*</span> Ticket Type
          </p>

          <div class="flex">
            <select
              class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
              v-model="state.formTicketType"
              @change="getTicketCategory(state.formTicketType)"
            >
              <option disabled value="">Select type</option>
              <option
                v-for="ticket in ticketTypes"
                :value="ticket?.Value"
                :key="ticket.id"
              >
                {{ ticket?.Label }}
              </option>
            </select>
          </div>
          <div
            class="input-errors text-sm text-red-500 mt-1"
            v-for="error of v$.formTicketType?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Ticket type is required</div>
          </div>
        </div>
        <div class="mt-2">
          <p class="block text-gray-700 text-sm font-bold mb-2">
            <span class="text-red-500">*</span> Ticket Category
          </p>
          <div class="flex">
            <select
              class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
              v-model="state.formTicketCategory"
              @change="getTicketSubCategory(state.formTicketCategory)"
              :disabled="ticketCategoryLoading || ticketCategories.length === 0"
            >
              <option disabled value="" v-if="!ticketCategoryLoading">
                Select category
              </option>
              <option v-if="ticketCategoryLoading" value="">Loading...</option>
              <option
                v-for="category in ticketCategories"
                :key="category.id"
                :value="category.InteractionCategoryId"
              >
                {{ category?.InteractionCategoryName }}
              </option>
            </select>
          </div>
          <div
            class="input-errors text-sm text-red-500 mt-1"
            v-for="error of v$.formTicketCategory?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Ticket category is required</div>
          </div>
        </div>

        <div class="mt-2">
          <p class="block text-gray-700 text-sm font-bold mb-2">
            <span class="text-red-500">*</span> Ticket Subcategory
          </p>
          <div class="flex">
            <select
              class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
              v-model="state.formTicketSubCategory"
              :disabled="
                ticketSubCategoryLoading || ticketSubCategories.length === 0
              "
            >
              <option disabled value="" v-if="!ticketSubCategoryLoading">
                Select subcategory
              </option>
              <option disabled value="" v-if="ticketSubCategoryLoading">
                Loading...
              </option>
              <option
                v-for="subcategory in ticketSubCategories"
                :key="subcategory.id"
                :value="subcategory.InteractionSubCategoryId"
              >
                {{ subcategory?.InteractionSubCategoryName }}
              </option>
            </select>
          </div>
          <div
            class="input-errors text-sm text-red-500 mt-1"
            v-for="error of v$.formTicketSubCategory?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Ticket subcategory is required</div>
          </div>
        </div>

        <div class="border-dotted border-2 bg-gray-100 rounded p-2 flex mt-3">
          <div class="flex w-full">
            <label
              for="dropzone-file"
              class="flex flex-col justify-center items-center w-full py-2 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
            >
              <div class="flex items-center w-full">
                <svg
                  aria-hidden="true"
                  class="mx-3 w-10 h-8 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  ></path>
                </svg>
                <div>
                  <p
                    v-if="ticketImageName === ''"
                    class="text-sm text-gray-500 dark:text-gray-400"
                  >
                    <span class="font-semibold">Click to upload</span>
                  </p>
                  <p
                    v-if="ticketImageName === ''"
                    class="text-xs text-gray-500 dark:text-gray-400"
                  >
                    SVG, PNG and JPG
                  </p>
                </div>
                <div class="text-[#8DC63F]">{{ ticketImageName }}</div>
              </div>
              <input
                id="dropzone-file"
                accept=".jpeg, .png, .jpg"
                @change="uploadImage()"
                type="file"
                class="hidden"
              />
            </label>
          </div>
        </div>
        <div
          class="input-errors text-sm text-red-500 mt-1"
          v-for="error of v$.base64Image?.$errors"
          :key="error.$uid"
        >
          <div class="error-msg">Ticket Image is required</div>
        </div>
        <div class="my-4">
          <p class="block text-gray-700 text-sm font-bold mb-2">
            Ticket Description Notes
          </p>
          <div class="flex">
            <textarea
              rows="4"
              class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
              cols="20"
              v-model="state.formDescription"
              placeholder="Enter any notes here..."
            >
            </textarea>
          </div>
          <div
            class="input-errors text-sm text-red-500 mt-1"
            v-for="error of v$.formDescription?.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">Form Description is required</div>
          </div>
        </div>
        <div class="my-4 md:flex">
          <button
            class="bg-[#09518C] text-sm w-full my-3 mr-4 flex justify-center items-center rounded-lg text-white uppercase font-bold py-1.5 px-2 lg:w-1/4 hover:bg-[#a1cbed]"
            @click="togglePage"
            :disabled="submitTicketLoading"
          >
            <font-awesome-icon class="mr-2" prefix="fad" icon="fa-arrow-left" />
            Back
          </button>
          <button
            :disabled="submitTicketLoading"
            :class="submitTicketLoading ? 'bg-gray-500' : 'bg-[#8DC63F]'"
            class="w-full my-3 mr-4 flex justify-center items-center rounded-lg text-white uppercase font-bold py-1.5 lg:w-3/4 hover:text-[#F58220] hover:bg-white hover:border-[#8DC63F] border transition-colors duration-300"
          >
            <span v-if="submitTicketLoading">
              <div role="status" class="flex justify-center w-full">
                <svg
                  class="inline mr-2 w-5 h-5 text-white animate-spin dark:text-gray-600 fill-[#8DC63F]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </span>
            <span v-else>Raise A ticket</span>
          </button>
        </div>
      </form>
    </div>

    <TicketModal v-if="isModalOpen" @close="isModalOpen = false">
      <template #message>
        <div class="text-center" v-if="ticketCreateMessage">
          <div class="mt-6">
            <font-awesome-icon
              class="text-green-600 z-20 h-20 w-20 py-2"
              icon="fa-check-circle"
            />
          </div>
          <div class="py-2">
            <div class="p-4 text-black">
              <div class="text-lg font-bold text-center">
                Ticket Created Successfully
              </div>
              <div class="mt-4 text-sm text-center font-normal">
                Kindly track processing status from Tickets menu using Case
                Number
                <div class="block font-bold">
                  {{ ticketCreateMessage }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="ticketCreateMessageError">
          <div class="">
            <font-awesome-icon
              class="text-red-600 z-20 h-28 py-2"
              icon="fa-exclamation-circle"
            />
          </div>
          <div class="py-2">
            <div class="p-4 text-black">
              <div class="text-lg font-bold text-center">
                Ticket request failed
              </div>
              <div class="mt-4 text-sm text-center font-bold">
                {{ ticketCreateMessageError }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </TicketModal>
  </div>
</template>

<script>
import { reactive, ref } from "@vue/reactivity";
import { toolkitAxios, engageAxios } from "@/env";
import { useStore } from "vuex";
import { computed, onMounted } from "@vue/runtime-core";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import TicketModal from "@/components/modals/modal";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
export default {
  components: {
    TicketModal,
    LoadingSpinner,
  },
  setup() {
    const mainPage = ref(true);
    const tickets = ref("");
    const store = useStore();
    const filter = ref("");
    const page = ref(1);
    const perPage = ref(20);
    const viewTicket = ref(false);
    const getCurrentData = ref("");
    const ticketTypes = ref("");
    const ticketCategories = ref("");
    const ticketSubCategories = ref("");
    const ticketImageName = ref("");
    const ticketCreateMessage = ref("");
    const ticketCreateMessageError = ref("");
    const isCreateOpen = ref(false);
    const isModalOpen = ref(false);
    // loading
    const ticketCategoryLoading = ref(false);
    const ticketSubCategoryLoading = ref(false);
    const loading = ref(false);
    const submitTicketLoading = ref(false);
    // for sumbit form
    const state = reactive({
      formTicketType: "",
      formTicketCategory: "",
      formTicketSubCategory: "",
      formDescription: "",
      base64Image: "",
    });

    const rules = {
      formTicketType: { required },
      formTicketCategory: { required },
      formTicketSubCategory: { required },
      formDescription: { required },
    };

    const isCreateModalVisible = computed(() => isCreateOpen.value);

    const onCreateToggle = () => {
      isCreateOpen.value = !isCreateOpen.value;
    };

    const v$ = useVuelidate(rules, state);

    const togglePage = () => {
      mainPage.value = !mainPage.value;
    };

    const openTIcketModal = (data) => {
      getCurrentData.value = data;
      viewTicket.value = true;
    };

    const closeTicketModal = () => {
      viewTicket.value = false;
    };

    const viewTicketModal = computed(() => viewTicket.value);

    const displayedTickets = computed(() => {
      tickets.value = store.state.getTickets;
      const startIndex = perPage.value * (page.value - 1);
      const endIndex = startIndex + perPage.value;
      if (filter.value.length > 1) {
        return tickets.value
          .filter(
            (tickets) =>
              tickets?.InteractionSubCategory?.toLowerCase().includes(
                filter.value.toLowerCase()
              ) ||
              tickets?.CaseNumber?.toLowerCase().includes(
                filter.value.toLowerCase()
              ) ||
              tickets?.CaseStatus?.toLowerCase().includes(
                filter.value.toLowerCase()
              )
          )
          .slice(startIndex, endIndex);
      } else {
        return tickets.value.slice(startIndex, endIndex);
      }
    });

    const uploadImage = () => {
      const file = document.querySelector("input[type=file]").files[0];
      const reader = new FileReader();

      let rawImg;
      reader.onloadend = () => {
        rawImg = reader.result;
        state.base64Image = rawImg;
      };

      reader.readAsDataURL(file);
      ticketImageName.value = file.name;
    };

    const submitTicket = async () => {
      v$.value.$touch();

      if (v$.value.$invalid) return;

      submitTicketLoading.value = true;

      await engageAxios
        .post("crm/case/employer/createcase", {
          channelsourceL: "Web",
          employerCode: store.state.getLoggedInUser.code,
          // agentCode: store.state.getLoggedInUser.rmu_code,
          caseOriginCode: "700000002",
          documents: state.base64Image,
          interactionType: state.formTicketType,
          interactionCategory: state.formTicketCategory,
          interactionSubCategory: state.formTicketSubCategory,
          caseDescription: state.formDescription,
        })
        .then((res) => {
          // console.log("I got here");
          const postData = {
            code: store.state.getLoggedInUser.code,
            agentCode: store.state.getLoggedInUser.rmu_code,
            caseNo: res.data.data.caseNumber,
          };

          toolkitAxios.post("case/case", postData).then(() => {
            ticketCreateMessage.value = res.data.data.caseNumber;
            submitTicketLoading.value = false;
            isModalOpen.value = true;
            submitTicketLoading.value = false;
          });

          state.base64Image = "";
          state.formTicketType = "";
          state.formTicketCategory = "";
          state.formTicketSubCategory = "";
          state.formDescription = "";
          ticketImageName.value = "";

          if (ticketCreateMessageError.value !== "")
            ticketCreateMessageError.value = "";

          v$.value.$reset();
        })
        .catch(() => {
          ticketCreateMessageError.value =
            "Ticket Submission Failed, please try again later";

          submitTicketLoading.value = false;
        });
      // .finally(() => {
      //   submitTicketLoading.value = false;
      // });
    };

    const getTicketType = async () => {
      const response = await engageAxios.get("crm/case/getInteractionTypes");

      ticketTypes.value = response.data.data;
    };

    const getTicketCategory = async (code) => {
      ticketCategoryLoading.value = true;

      const response = await engageAxios.get(
        `crm/case/employer/getinteractioncategories/${code}`
      );
      // console.log(response.data, "datad");
      ticketCategories.value = response.data.data;

      ticketCategoryLoading.value = false;
    };

    const getTicketSubCategory = async (code) => {
      ticketSubCategoryLoading.value = true;

      const response = await engageAxios.get(
        `crm/case/employer/getinteractionsubcategories/${code}`
      );

      ticketSubCategories.value = response.data.data;

      ticketSubCategoryLoading.value = false;
    };

    onMounted(() => {
      getTicketType();
    });

    return {
      mainPage,
      togglePage,
      // getTickets,
      tickets,
      filter,
      displayedTickets,
      page,
      perPage,
      viewTicketModal,
      openTIcketModal,
      closeTicketModal,
      getCurrentData,
      getTicketType,
      ticketTypes,
      getTicketCategory,
      ticketCategories,
      ticketSubCategories,
      getTicketSubCategory,
      ticketCategoryLoading,
      ticketSubCategoryLoading,
      loading,
      uploadImage,
      ticketImageName,
      ticketCreateMessage,
      submitTicket,
      state,
      v$,
      submitTicketLoading,
      // submitToolkitTicket,
      isCreateModalVisible,
      onCreateToggle,
      isCreateOpen,
      isModalOpen,
      ticketCreateMessageError,
    };
  },
};
</script>

<style scoped>
@media (min-width: 1100px) {
  .grid-cols-3-custom {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>

<style>
.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 500ms ease-out;
}

.fade-leave-to {
  opacity: 0;
}
</style>
